import { Switch, Route } from "react-router-dom";
import StudentPages from "../../constants/StudentPages";
import Loading from "../Loading"


function StudentMain() {
    if (false) return <Loading />;

    let pages = new StudentPages();
    let siteNamesByRoute: JSX.Element[] = pages.pages.map(page => <Route key={page.name} path={page.path}>{page.name}</Route>); //Header level in "tehtävät"
    let siteContentsByRoute: JSX.Element[] = pages.pages.map(page => <Route key={page.name} path={page.path}>{page.content}</Route>);

    return (
        <div className="py-10 block h-full max-h-full">
            <header className="mx-auto px-4 sm:px-6 lg:px-8">
                <h1 className="text-3xl font-bold leading-tight text-gray-900">
                    <Switch>
                        {siteNamesByRoute}
                    </Switch>
                </h1>
            </header>
            <main className="flex w-full px-4 py-8 sm:px-0 mx-auto lg:px-8">
                <Switch>
                    {siteContentsByRoute}
                </Switch>
            </main>
        </div>
    );
}

export default StudentMain;